import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ISearchFilter } from './search.filters.interface';

@Component({
    selector: 'mlp-ng-search-filters',
    templateUrl: './search.filters.component.html',
    styleUrls: ['./search.filters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class SearchFiltersSharedComponent {
    visible = false;
    selectedSection = '';

    @Input() searchFilter: ISearchFilter;

    setVisible(section: string): void {
        if (section === this.selectedSection) {
            this.visible = false;
            this.selectedSection = '';

            return;
        }

        this.selectedSection = section;
        this.visible = true;
    }

    method(item, val): void {
        this.searchFilter.form.controls[item].setValue(val);
    }
}
